import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  FormControl,
  Radio,
  Typography,
} from "@mui/material";
import { UseB2BOffers } from "./UseB2BOffers";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { useRecoilState } from "recoil";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { removeComma, toMoney } from "../../../util/Utils";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditB2BOffer() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const { validate, getOfferByID, updateOffer } = UseB2BOffers();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    totalCost: undefined,
    offerPercent: undefined,
    description: undefined,
    isActive: false,
  });

  const [errorState, setErrorState] = useState({
    description: false,
    totalCost: false,
    offerPercent: false,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getOfferByID(location.state.id, (callback) => {
        setState(callback);
      });
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/b2borders" },
          { name: "ویرایش آفر", url: "/b2borders/editB2BOffer" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            value={state.description ? state.description : ""}
            error={errorState.description}
            label="توضیحات"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, description: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            id="outlined-basic"
            label="مجموع خرید"
            size="small"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            error={errorState.totalCost}
            value={state.totalCost ? toMoney(state.totalCost) : ""}
            onChange={(evt) => {
              setState({
                ...state,
                totalCost: removeComma(evt.target.value),
              });
            }}
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            fullWidth
            id="outlined-basic"
            label="درصد کمیسیون"
            size="small"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            value={state.offerPercent ? toMoney(state.offerPercent) : ""}
            error={errorState.offerPercent}
            onChange={(evt) => {
              setState({
                ...state,
                offerPercent: removeComma(evt.target.value),
              });
            }}
            variant="outlined"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}

        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2 }}
          gridColumn={isSmall ? "span 12" : "span 3"}
        >
          <Typography>وضعیت :</Typography>
          <FormControl
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={state.isActive}
              onChange={(event) => {
                setState({
                  ...state,
                  isActive: event.target.value,
                });
              }}
            >
              <FormControlLabel value={true} control={<Radio />} label="فعال" />
              <FormControlLabel
                value={false}
                control={<Radio />}
                label="غیرفعال"
              />
            </RadioGroup>
          </FormControl>
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}

        <Box
          gridColumn={isSmall ? "span 12" : "span 3"}
          sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            sx={{ mr: 2, width: "70px" }}
            variant="contained"
            onClick={() => {
              if (validate(state, setErrorState, true) == 200) {
                setProgress(true);
                updateOffer(state, () => {
                  navigate("/b2borders", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "70px" }}
            variant="outlined"
            onClick={() => {
              navigate("/b2borders", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
      </Box>
    </Detail>
  );
}
